import React from "react";
import "../Page.css";
import cloudflare_icon from "../../Assets/security/cloud-flare.svg";
import shieldCross from "../../Assets/security/shield-cross.png"
import shield from "../../Assets/security/security.png"
import bot from "../../Assets/security/bot.png"
import lock from "../../Assets/security/lock.png"
import gauge from "../../Assets/security/gauge.png"
import eye from "../../Assets/security/eye.png"
import link from "../../Assets/security/link.png"
import filter from "../../Assets/security/filter.png"
import SecurityCard1 from "./securityCards/SecurityCards";

const Cloudflare = () => {
    const cloudflareProtections = [
        {
          title: "DDoS Protection",
          description: "Blocks volumetric attacks before reaching your server.",
          logo: shieldCross,
          status: 1
        },
        {
          title: "WAF",
          description: "Web Application Firewall blocks OWASP Top 10 threats.",
          logo: shield,
          status: 1
        },
        {
          title: "Bot Management",
          description: "Distinguishes bad bots from real users.",
          logo: bot,
          status: 1
        },
        {
          title: "SSL/TLS Mode",
          description: "Secures all requests via HTTPS at the edge.",
          logo: lock,
          status: 1
        },
        {
          title: "Custom Rate Limiting Rules",
          description: "Prevent API scraping with per-route limits.",
          logo: gauge,
          status: 1
        },
        {
          title: "IP Reputation & Threat Feed",
          description: "Block or challenge bad actors automatically.",
          logo: eye,
          status: 1
        },
        {
          title: "Page Rules (Force HTTPS, Cache)",
          description: "Optimize traffic handling for performance and safety.",
          logo: link,
          status: 1
        },
        {
          title: "Firewall Rules",
          description: "Define custom logic to block suspicious requests.",
          logo: filter,
          status: 1
        }
      ];

    return (
        <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" ,flexDirection:"column",gap:"20px"}}>
            <div className="component-card">
                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Cloudflare</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={cloudflare_icon} />

                </div>
                <div className="security_features">
                    {cloudflareProtections.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Cloudflare;